module.exports = __webpack_public_path__ + "img/Carson.a4b0e59c.jpg";